export default class WEBVariableClass {

    idNTipoVariableWEB: number | null;
    fldTNombre: string | null;

    constructor() {
        this.idNTipoVariableWEB = null;
        this.fldTNombre = null;
    }

}